"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrganisationFilterModule = /** @class */ (function () {
    function OrganisationFilterModule() {
    }
    return OrganisationFilterModule;
}());
exports.OrganisationFilterModule = OrganisationFilterModule;
